module.exports = __webpack_public_path__ + "images/favicon.development.ico";


//////////////////
// WEBPACK FOOTER
// ./images/favicon.development.ico
// module id = 1112
// module chunks = 1